// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/header/Breadcrumbs.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/header/Breadcrumbs.tsx");
  import.meta.hot.lastModified = "1771759207302.443";
}
// REMIX HMR END

import { NavLink, useMatches, useParams } from "@remix-run/react";
import SYS_CONFIG from "~/config";
import { tourismDataIndex } from "~/resources/static_data";
import TriangleRightIconSVG from "~/resources/svgs/TriangeRightIconSVG";
import { extractDataFromMatch, getMatchFromMatchesByPageHandle, usePathHandle } from "~/utils/handle";
import { langByParam } from "~/utils/lang";
import { useLang } from "~/utils/provider/lang-provider";
const {
  PAGE_HANDLES: {
    H_GUIDE,
    H_GUIDE_WITH_DATA,
    H_KANTONSRAT_PERSONEN_FEED,
    H_KANTONSRAT_PERSONEN_ITEM,
    H_KANTONSRAT_MITGLIEDER_FEED,
    H_KANTONSRAT_MITGLIEDER_ITEM,
    H_KANTONSRAT_KOMMISSIONEN,
    H_KANTONSRAT_SITZUNGEN_FEED,
    H_KANTONSRAT_SIZTUNGEN_ITEM,
    H_KANTONSRAT_FRAKTIONEN,
    H_KANTONSRAT_WAHLKREISE,
    H_KANTONSRAT_GESCHAEFTE_FEED,
    H_KANTONSRAT_GESCHAEFTE_ITEM,
    H_ABOUT,
    H_PRIVACY,
    H_NEWS
  },
  ROUTE_FRAGMENTS: {
    RF_GUIDE,
    RF_EYZ,
    RF_RAPPERSWIL_ZUERICHSEE,
    RF_ZUERICH,
    RF_KANTONSRAT,
    RF_PAGE,
    RF_PERSONEN,
    RF_MITGLIEDER,
    RF_SITZUNGEN,
    RF_KOMMISSIONEN,
    RF_GESCHAEFTE //, RF_ABOUT, RF_PRIVACY
    ,
    RF_NEWS
  }
} = SYS_CONFIG;
const crateBreadcrumbConfigKantonsrat = ({
  params,
  pageHandle,
  matches
}) => {
  const {
    lang,
    page,
    id
  } = params;
  const langObj = langByParam(lang);

  // console.log({ pageHandle })

  let pathAcc = langObj.lang_param ? `/${langObj.lang_param}/${RF_KANTONSRAT}` : `/${RF_KANTONSRAT}`;
  let crumbs = [{
    label: 'c_home',
    path: langObj.lang_param ? `/${langObj.lang_param}` : `/`,
    useDict: true
  }, {
    label: 'c_kantonsrat',
    path: pathAcc,
    useDict: true
  }];
  if (pageHandle === H_KANTONSRAT_PERSONEN_FEED) {
    pathAcc += `/${RF_PERSONEN}`;
    crumbs = [...crumbs, {
      path: pathAcc,
      label: 'c_personen',
      useDict: true
    }];
    if (page) {
      pathAcc += `/${RF_PAGE}/${page}`;
      crumbs = [...crumbs, {
        path: pathAcc,
        label: 'c_page',
        addToLabel: page,
        useDict: true
      }];
    }
  } else if (pageHandle === H_KANTONSRAT_PERSONEN_ITEM) {
    pathAcc += `/${RF_PERSONEN}`;
    crumbs = [...crumbs, {
      path: pathAcc,
      label: 'c_personen',
      useDict: true
    }];
    pathAcc += `/id/${id}`;
    const possiblyData = getMatchFromMatchesByPageHandle(matches, H_KANTONSRAT_PERSONEN_ITEM)?.data;
    if (possiblyData && typeof possiblyData === 'object' && 'personen' in possiblyData) {
      const possiblyPersonen = possiblyData?.personen && Array.isArray(possiblyData.personen) ? possiblyData.personen[0] : null;
      if (possiblyPersonen) {
        crumbs = [...crumbs, {
          path: pathAcc,
          label: `${possiblyPersonen[2]} ${possiblyPersonen[1]}`,
          useDict: false
        }];
      }
    }
  } else if (pageHandle === H_KANTONSRAT_MITGLIEDER_FEED) {
    pathAcc += `/${RF_MITGLIEDER}`;
    crumbs = [...crumbs, {
      path: pathAcc,
      label: 'c_mitglieder',
      useDict: true
    }];
  } else if (pageHandle === H_KANTONSRAT_MITGLIEDER_ITEM) {
    try {
      const possiblyData = getMatchFromMatchesByPageHandle(matches, H_KANTONSRAT_MITGLIEDER_ITEM)?.data;
      // @ts-expect-error asdf
      const possiblyItem = possiblyData?.feed[0];
      pathAcc += `/${RF_MITGLIEDER}`;
      crumbs = [...crumbs, {
        path: pathAcc,
        label: 'c_mitglieder',
        useDict: true
      }, {
        path: '',
        label: `${possiblyItem.vorname} ${possiblyItem.name}`,
        useDict: false
      }];
    } catch {
      null;
    }
  } else if (pageHandle === H_KANTONSRAT_FRAKTIONEN) {
    // c_fraktionen

    pathAcc += `/${RF_MITGLIEDER}`;
    crumbs = [...crumbs, {
      path: pathAcc,
      label: 'c_fraktionen',
      useDict: true
    }];
  } else if (pageHandle === H_KANTONSRAT_WAHLKREISE) {
    pathAcc += `/${RF_MITGLIEDER}`;
    crumbs = [...crumbs, {
      path: pathAcc,
      label: 'c_wahlkreise',
      useDict: true
    }];
  } else if (pageHandle === H_KANTONSRAT_KOMMISSIONEN) {
    pathAcc += `/${RF_KOMMISSIONEN}`;
    crumbs = [...crumbs, {
      path: pathAcc,
      label: 'c_kommissionen',
      useDict: true
    }];
    if (id) {
      crumbs = [...crumbs, {
        path: pathAcc,
        label: id,
        useDict: false
      }];
    }
  } else if (pageHandle === H_KANTONSRAT_SITZUNGEN_FEED) {
    pathAcc += `/${RF_SITZUNGEN}`;
    crumbs = [...crumbs, {
      path: pathAcc,
      label: 'c_sitzungen',
      useDict: true
    }];
  } else if (pageHandle === H_KANTONSRAT_SIZTUNGEN_ITEM && id) {
    try {
      const possiblyData = getMatchFromMatchesByPageHandle(matches, H_KANTONSRAT_SIZTUNGEN_ITEM)?.data;
      // @ts-expect-error asdf 
      const possiblyItem = possiblyData?.feed[0];

      // console.log({ possiblyItem, possiblyData})

      pathAcc += `/${RF_SITZUNGEN}`;
      crumbs = [...crumbs, {
        path: pathAcc,
        label: 'c_sitzungen',
        useDict: true
      }, {
        path: '',
        label: possiblyItem?.titel,
        useDict: false
      }];
    } catch {
      null;
    }
  } else if (pageHandle === H_KANTONSRAT_GESCHAEFTE_FEED) {
    pathAcc += `/${RF_GESCHAEFTE}`;
    crumbs = [...crumbs, {
      path: pathAcc,
      label: 'c_geschaefte',
      useDict: true
    }];
  } else if (pageHandle === H_KANTONSRAT_GESCHAEFTE_ITEM && id) {
    try {
      const possiblyData = getMatchFromMatchesByPageHandle(matches, H_KANTONSRAT_GESCHAEFTE_ITEM)?.data;
      // @ts-expect-error asdf 
      const possiblyItem = possiblyData?.feed[0];
      pathAcc += `/${RF_GESCHAEFTE}`;
      crumbs = [...crumbs, {
        path: pathAcc,
        label: 'c_geschaefte',
        useDict: true
      }, {
        path: pathAcc,
        label: possiblyItem?.krnr,
        useDict: false
      }];
    } catch {
      //console.log({ err })
      null;
    }
  }
  let crumbsOut = [];
  for (let i = 0; i < crumbs.length; i += 1) {
    crumbsOut = [...crumbsOut, {
      ...crumbs[i],
      isLast: i + 1 === crumbs.length,
      position: i + 1
    }];
  }
  return crumbsOut;
};
const createBreadcrumbConfigMain = ({
  params,
  page,
  matches
}) => {
  const {
    lang,
    region,
    category,
    id,
    slug
  } = params;
  const langObj = langByParam(lang);
  const lang_code = langObj.lang_code;
  const idx = tourismDataIndex;
  let pathAcc = `/${langObj.lang_param}`;
  let crumbs = [{
    label: 'c_home',
    path: pathAcc,
    useDict: true
  }];
  if (page === H_GUIDE) {
    pathAcc += pathAcc === '/' ? RF_GUIDE : `/${RF_GUIDE}`;
    crumbs = [...crumbs, {
      path: pathAcc,
      label: 'c_explore',
      useDict: true
    }];
    if (region) {
      pathAcc += `/${region}`;
      if (region === RF_ZUERICH) {
        crumbs = [...crumbs, {
          path: pathAcc,
          label: 'c_zuerich',
          useDict: true
        }];
      } else if (region === RF_RAPPERSWIL_ZUERICHSEE) {
        crumbs = [...crumbs, {
          path: pathAcc,
          label: 'c_rapperswil',
          useDict: true
        }];
      } else if (region === RF_EYZ) {
        crumbs = [...crumbs, {
          path: pathAcc,
          label: 'c_einsiedeln',
          useDict: true
        }];
      }
      if (category) {
        const entry = idx.get(category);
        if (entry) {
          if (entry.name[lang_code]) {
            crumbs = [...crumbs, {
              path: pathAcc,
              label: entry.name[lang_code],
              useDict: false
            }];
          } else if (entry.name.en) {
            crumbs = [...crumbs, {
              path: pathAcc,
              label: entry.name.en,
              useDict: false
            }];
          } else if (entry.name.de) {
            crumbs = [...crumbs, {
              path: pathAcc,
              label: entry.name.de,
              useDict: false
            }];
          }
        }
      } else if (id) {
        const possiblyData = getMatchFromMatchesByPageHandle(matches, H_GUIDE_WITH_DATA)?.data;
        const data = extractDataFromMatch(possiblyData);
        if (data && 'name' in data) {
          if (data.name) {
            crumbs = [...crumbs, {
              path: pathAcc,
              label: data.name,
              useDict: false
            }];
          }
        }
      }
    }
  } else if (page === H_ABOUT) {
    crumbs = [...crumbs, {
      path: pathAcc,
      label: 'c_about',
      useDict: true
    }];
  } else if (page === H_PRIVACY) {
    crumbs = [...crumbs, {
      path: pathAcc,
      label: 'c_privacy',
      useDict: true
    }];
  } else if (page === H_NEWS) {
    pathAcc += pathAcc === '/' ? RF_NEWS : `/${RF_NEWS}`;
    crumbs = [...crumbs, {
      path: pathAcc,
      label: 'c_news',
      useDict: true
    }];
    if (id && slug) {
      // @ts-expect-error is string
      const possiblyTitle = getMatchFromMatchesByPageHandle(matches, H_NEWS)?.data?.item?.title;
      crumbs = [...crumbs, {
        path: pathAcc,
        label: possiblyTitle,
        useDict: false
      }];
    }
  }
  let crumbsOut = [];
  for (let i = 0; i < crumbs.length; i += 1) {
    crumbsOut = [...crumbsOut, {
      ...crumbs[i],
      isLast: i + 1 === crumbs.length,
      position: i + 1
    }];
  }
  return crumbsOut;
};
export const BreadCrumbFragment = ({
  label,
  position,
  path,
  isLast,
  addToLabel
}) => <div itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem" className="crumb_item">
        {!isLast && path ? <NavLink end itemProp="item" to={path}>
                <span itemProp="name">
                    {label}{addToLabel ? ` ${addToLabel}` : ''}
                </span>
                <meta itemProp="position" content={position.toString()} />
            </NavLink> : <span>
                <span itemProp="name">
                    {label}{addToLabel ? ` ${addToLabel}` : ''}
                </span>
                <meta itemProp="position" content={position.toString()} />
            </span>}
        {!isLast ? <TriangleRightIconSVG aria-label="nächste" /> : null}
    </div>;
_c = BreadCrumbFragment;
export function BreadcrumbsMain() {
  _s();
  const pathHandle = usePathHandle();
  const l_metas = useLang('metas');
  const params = useParams();
  const matches = useMatches();
  const crumbConfig = createBreadcrumbConfigMain({
    params,
    matches,
    page: pathHandle
  });
  return <div itemScope itemType="https://schema.org/BreadcrumbList" className="crumbs padding05rem">
            {crumbConfig.map((it, ind) => <BreadCrumbFragment key={ind} isLast={it.isLast} position={it.position} label={it.useDict ? l_metas(it.label) : it.label}
    //label={it.label}
    path={it.path} />)}
        </div>;
}
_s(BreadcrumbsMain, "YNgjWe+ZhuIR++HrZECNJkl8Hck=", false, function () {
  return [usePathHandle, useLang, useParams, useMatches];
});
_c2 = BreadcrumbsMain;
export function BreadcrumbsKantonsrat() {
  _s2();
  const pathHandle = usePathHandle();
  const l_metas = useLang('metas');
  const params = useParams();
  const matches = useMatches();
  const crumbConfig = crateBreadcrumbConfigKantonsrat({
    params,
    matches,
    pageHandle: pathHandle
  });
  return <div itemScope itemType="https://schema.org/BreadcrumbList" className="crumbs padding05rem">
            {crumbConfig.map((it, ind) => <BreadCrumbFragment key={ind} isLast={it.isLast} position={it.position} label={it.useDict ? l_metas(it.label) : it.label}
    //label={it.label}
    path={it.path} addToLabel={it?.addToLabel} />)}
        </div>;
}
_s2(BreadcrumbsKantonsrat, "YNgjWe+ZhuIR++HrZECNJkl8Hck=", false, function () {
  return [usePathHandle, useLang, useParams, useMatches];
});
_c3 = BreadcrumbsKantonsrat;
var _c, _c2, _c3;
$RefreshReg$(_c, "BreadCrumbFragment");
$RefreshReg$(_c2, "BreadcrumbsMain");
$RefreshReg$(_c3, "BreadcrumbsKantonsrat");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;